<template>
  <form ref="fileUploadForm" >
    <div class="form-inline">
      <!--<label>Upload: </label>-->
      <input type="file"
             enctype="multipart/form-data"
             id="file"
             ref="file" @change.prevent.stop="handleFileUpload"
             class="form-control form-control-file mr-md-2 mr-2"/>
      <input type='hidden' id='file-csrf-id' :name='csrfParam' :value='csrfToken'/>
    </div>
  </form>
</template>
<script>
import router from '@/router/index';
import { mapGetters, mapActions } from 'vuex';
import { INIT_NO_OP_NUM, CDA_FILE_TYPE, PDF_FILE_TYPE, DEVICE_CSV_FILE_TYPE } from '@/config';
import { CdasNavigation,PdfsNavigation, DataUploadNavigation } from '@/store/modules/fsm/messages';
import { scanCdaById } from '@/api/cdaApi';
import { getAllData } from '@/api/sessionApi';
import { uploadBloodPressureDeviceCsv } from '@/api/deviceApi';
export default {
  name: 'file-upload',
  props: {
    fileType: '',
  },
  computed: {
    ...mapGetters('login', {
      csrf : 'getCsrf'
    }),
    csrfParam() {
      return this.csrf.param
    },
    csrfToken() {
      return this.csrf.token
    },
    ...mapGetters('login/cda', {
      indexOfLastCda: 'getIndexOfLastCda'
    }),
    ...mapGetters('login/pdf', {
      indexOfLastPdf: 'getIndexOfLastPdf'
    }),
    indexOfLast () {
      return (this.fileType === CDA_FILE_TYPE)
      ? this.indexOfLastCda
      : this.indexOfLastPdf === -1 ? -1 : 0
    }

  },
    methods: {
      ...mapActions('login',[
        'updateApplicationModel'
      ]),
      ...mapActions('login/cda', [
        'uploadCda'
      ]),
      ...mapActions('login/pdf', [
        'uploadPdf'
      ]),
      ...mapActions('login/watch',[
        'setExternalMeasuresLoaded'
      ]),
      handleFileUpload () {
        this.updateFileRef();

        let upload = null;
        let contentRouteName = '';
        let actionField = null;
        let loader = null;
        if (this.fileType === CDA_FILE_TYPE) {
          upload = this.uploadCda;
          contentRouteName = CdasNavigation;
          actionField = 'ccda';
        } else if (this.fileType === PDF_FILE_TYPE) {
          upload = this.uploadPdf;
          contentRouteName = PdfsNavigation;
          actionField = 'pdf';
        } else if (this.fileType === DEVICE_CSV_FILE_TYPE) {
          upload = uploadBloodPressureDeviceCsv;
        } else {
          this.$swal({
            type: 'error',
            title: 'Unable to upload',
            text: `No channel to upload file of type '${this.fileType}'`,
          })
        }

        /**
         * send ajax file upload request to server
         */
        if (!this.file) {
          this.$swal({
            type: 'error',
            title: 'Unable to upload',
            text: 'Please try again or choose another file.',
          })
        } else {
          this.$swal({
            title: `Upload ${this.file.name}`,
            text: 'This may take a while. Please do not refresh this page while it is uploading.',
            type: 'warning',
            showCancelButton: true,
            cancelButtonColor: '#d33',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Yes, upload',
            reverseButtons: true,
          }).then((result) => {
            if (result.value) {
              loader = this.$loading.show({
                container: this.$refs.pageBody
              },{
                after: this.$createElement('div',{},[`Uploading ${this.fileType}...`])
              });

              let formData = new FormData();
              formData.append('file-field', this.file);
              //TODO: use this to parameterize devices?
              formData.append('action-field', actionField);
              formData.append(this.csrfParam,this.csrfToken);
              
              // dispatch 'upload*' action
              //TODO: use uploadFile from fileApi in the future
              upload(formData)
              .then( (id) => {
                if (this.fileType === CDA_FILE_TYPE) {
                  // update loader text
                  loader.hide();
                  loader = this.$loading.show({
                    container: this.$refs.pageBody
                  },{
                    after: this.$createElement('div',{},[`Scanning CDA...`])
                  });

                  return scanCdaById(id);
                }
                return;
              })
              .then(() => {

                // update loader text
                loader.hide();
                loader = this.$loading.show({
                  container: this.$refs.pageBody
                },{
                  after: this.$createElement('div',{},[`Updating application data...`])
                });

                if (this.fileType === DEVICE_CSV_FILE_TYPE) {
                  this.setExternalMeasuresLoaded(false);
                  return;
                };
                return this.updateApplicationModel();
                
              })
              .then(()=>{
                if (this.fileType === DEVICE_CSV_FILE_TYPE) {
                  this.$swal({
                    type: 'success',
                    title: 'Device data uploaded',
                    text: 'You can go to the Watch/Vitals pages to view data.'
                  });
                }

                if (!contentRouteName) return;
                if(this.fileType === PDF_FILE_TYPE)
                  router.push({ name: contentRouteName, params: {selectedPdf:this.indexOfLast} });
                else
                  router.push({ name: contentRouteName, params: {index:this.indexOfLast} });
              })
              .catch( (err) => {
                this.$swal({
                  type: 'error',
                  title: 'Unable to upload',
                  text: err,
                });
                console.error(err);
              })
              .finally( () => {
                loader.hide();
                loader = null;
              });
            }
          });

        }


      },

      /**
       * updates reference to local file for the file chooser
       */
      updateFileRef () {
        this.file = this.$refs.file.files[0];
      }
    },
  }
</script>

<style scoped lang="scss">
  .btn {
    font-size: 0.9rem;
  }
  input[type="text"] {
    font-size: 0.9rem;
  }
  input[type="file"] {
    font-size: 12px;
    margin: 0;
    height: 100%;
    /*width: 70%;*/
  }
</style>
